import styled from 'styled-components'
import { colors, device, hideScrollbar } from '../../styles/GlobalVariables'
import Link from '../Link/Link'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  margin-bottom: 30px;

  ${device.medium} {
    margin-bottom: 28px;
  }
`

export const FiltersContainer = styled.div`
  overflow-x: auto;
  position: relative;
  ${hideScrollbar}
  margin: 0 -20px 20px;
  background: ${colors.lightGray2};

  ${device.medium} {
    background: transparent;
    margin: 0 0 12px;
  }
`

export const FiltersScrollArea = styled.div<{ filterIndex: number }>`
  display: flex;
  align-items: center;
  padding: 0 8px;
  height: 36px;

  > span {
    height: 36px;
    padding: 9px 12px;
    flex-shrink: 0;
    font-size: 18px;
    font-weight: 600;
    line-height: 1;
    color: ${colors.darkGray2};
    z-index: 2;
    cursor: pointer;
    position: relative;

    :nth-child(${props => props.filterIndex + 1}) {
      color: ${colors.white};
      font-weight: 700;
      text-decoration: underline;

      ${device.medium} {
        font-size: 24px;
      }
    }

    :last-child {
      padding-left: 20px;

      ${device.medium} {
        padding-left: unset;
      }
    }
  }

  ${device.medium} {
    padding: 0;
    height: 50px;

    > span {
      font-weight: 500;
      font-size: 20px;
    }
  }
`

export const ShowsGrid = styled.div`
  flex: 1;
  display: grid;
  gap: 12px 7px;
  grid-template-columns: repeat(3, 1fr);

  ${device.medium} {
    grid-template-columns: repeat(5, 234px);
    gap: 32px 22.5px;
  }

  ${device.large} {
    gap: 32px 30px;
  }
`

export const Show = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`

export const PosterLink = styled(Link)`
  flex: 1;
  display: flex;

  min-height: 190px;
  max-height: 190px;

  > img {
    flex: 1;
    min-width: 0;
    object-fit: cover;
  }

  ${device.medium} {
    min-height: 416px;
    max-height: 416px;
  }
`

export const Title = styled.a`
  display: none;

  ${device.medium} {
    display: -webkit-box;
    max-height: calc(1 * 20px);
    -webkit-box-orient: vertical;
    font-size: 20px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    color: ${colors.white};
  }
`
